export default {"src":"/_next/static/media/apk-qr-primexbt-co-za.c6385ed0.svg","height":225,"width":225,"blurWidth":0,"blurHeight":0};